import type { JSX, PropsWithChildren } from "react";

import { VStack } from "@/ui/layout/Stacks";
import { LayoutToken } from "@/ui/theme/tokens";

interface CarouselWrapperProps extends PropsWithChildren {
  hasPaddingTop?: boolean;
  header?: JSX.Element;
}

const CarouselWrapper = ({
  children,
  hasPaddingTop = true,
  header,
}: CarouselWrapperProps) => {
  const padding = LayoutToken.ContentPaddingHorizontal;
  return (
    <VStack gap={12}>
      {header && (
        <VStack
          paddingLeft={padding}
          paddingRight={padding}
          paddingTop={hasPaddingTop ? padding : null}
        >
          {header}
        </VStack>
      )}
      <VStack>{children}</VStack>
    </VStack>
  );
};

export default CarouselWrapper;
